import { StatsReportsIdsEnum } from '@empathybroker/tsclient-stats/dist/enums/stats-reports-ids.enum';

import { Store } from 'vuex';

import { CONTAINER, TYPES } from '../../../config';

import { ANALYTICS_CONSTS } from '../../../store/analytics/analytics.consts';

export default class DataProvider {

  /**
   * Merges two data sets, keeping force simulation positions and velocities
   * @param data
   * @param newData
   * @returns {Array}
   */
  mergeData(data, newData, options): any {
    options.events.forEach(event => {
      if (newData[event]) {
        newData[event].forEach(n => {
          let inJoin = false;
          data[event].forEach(d => {
            if (n.query.trim().toLowerCase() === d.query.trim().toLowerCase()) {
              n.index = d.index;
              n.x = d.x;
              n.y = d.y;
              n.vx = d.vx;
              n.vy = d.vy;
              inJoin = true;
            }
          });
          if (!inJoin) { // Generate random starting positions in the outside quarters
            n.x = Math.random() < .5 ? Math.floor(Math.random() * options.width / 4) : options.width -
              Math.floor(Math.random() * options.width / 4);
            n.y = Math.random() < .5 ? Math.floor(Math.random() * options.height / 4) : options.height -
              Math.floor(Math.random() * options.height / 4);
          }
        });
      }
    });

    return newData;
  }

  /**
   * Retrieves data from two Stats API endpoints and formats the response into the expect format for the now visualisation module.
   * @returns {Object} The promise to deliver the data repsonse of both endpoints.
   */
  getData(): Promise<void> {
    return new Promise((resolve: Function, reject: Function): void => {
      const store = CONTAINER.get<Store<any>>(TYPES.Store);
      store.dispatch(`${ ANALYTICS_CONSTS.moduleName }/${ ANALYTICS_CONSTS.actions.fetchStatsReport }`, {
        id: StatsReportsIdsEnum.TRENDING,
        params: {}
      })
        .then((trendingResponse: any): void => {
          if (!trendingResponse || !trendingResponse.data || !trendingResponse.data.totals) {
            reject(`Error retrieving trending data: ${ trendingResponse }`);
          }
          resolve({
            trends: trendingResponse.data,
            stats: {
              query_count: trendingResponse.data.totals.queryCount,
              click_count: trendingResponse.data.totals.clickCount,
              no_results_count: trendingResponse.data.totals.noResultsCount
            }
          });
        })
        .catch((error) => reject(error));
    });
  }

}
